module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-12.abe6070b.png";